export class PrintManager {

    // #region Print Code
    //Code print Sp LAI Diag
    public static code_Print_Diag_Sp_LAI = "Diag_Sp_LAI";
    //Code print Annuals Diag
    public static code_Print_Diag_Annuals = "annuals";
    //Code print Preconisation Modulation
    public static code_Print_Modulation = "modulation";
    //Code print organique
    public static code_Print_Orga_Ferti = 'fumure organique'
    //Code print Advice LAI
    public static code_Print_Advice_Sp_LAI = "Adv_Sp_LAI";
    //Code print Preocnisation LAI
    public static code_Print_Preco_Sp_LAI = "Preco_Sp_LAI";
    //Code print Intervention mode preconisation
    public static code_Print_Inter_Mode_Preco = "InterModePreco";
    //Code print Synthesis of the ferti (preco+Pilot Sp)
    public static code_Print_Synt_Fertis = "SynthFertis";
    //Code print Synthesis of the preco other inputs (modulation)
    public static code_Print_Synt_Other_Inputs = "SynthOInputs";

    //Code print Solde conseil Pk Initial (fumure)
    public static code_Print_Advice_Pk_Init_Balance = "AdvInitBalancePk";
    //Code print Solde conseil Pk Ferti (fumure)
    public static code_Print_Advice_Pk_Ferti_Balance = "AdvFertiBalancePk";

    //Dossier Réglementaire Pilotage Azote SP  propre au module conseil LAI
    public static code_print_regulatory_pilot_lai ="RegulatoryAdviceSp"
    //#endregion

    /**
     * Format en Pdf type (to the list user)
     * for the print Synthesis of the ferti (preco+Pilot Sp)
     * @returns PrintPdfExtraModel
     */
    public static FormatPdfTypeSynthesisFert(): PrintPdfExtraModel {
        return new PrintPdfExtraModel(PrintManager.code_Print_Synt_Fertis, "Synthèse des besoins en engrais", eDownloadPdfs.SynthFertilizerNeeds)
    }

    /**
    * Format en Pdf type (to the list user)
    * for the print Synthesis of the preco other inputs (modulation)
    * @returns PrintPdfExtraModel
    */
    public static FormatPdfTypeSynthesisOtherInputs(): PrintPdfExtraModel {
        return new PrintPdfExtraModel(PrintManager.code_Print_Synt_Other_Inputs, "Synthèse des besoins en autres intrants", eDownloadPdfs.SynthOtherInputNeeds)
    }

    /**
   * Format en Pdf type (to the list user)
   * for the print Advice Pk Balance Initial
   * @returns PrintPdfExtraModel
   */
    public static FormatPdfTypeBalanceInitialAdvicePk(): PrintPdfExtraModel {
        return new PrintPdfExtraModel(PrintManager.code_Print_Advice_Pk_Init_Balance, "Cartes des soldes initiaux", eDownloadPdfs.AdviceInitialBalancePk)
    }
    /**
   * Format en Pdf type (to the list user)
   * for the print Advice Pk Balance Ferti
   * @returns PrintPdfExtraModel
   */
    public static FormatPdfTypeBalanceFertiAdvicePk(): PrintPdfExtraModel {
        return new PrintPdfExtraModel(PrintManager.code_Print_Advice_Pk_Ferti_Balance, "Carte des soldes réactualisés", eDownloadPdfs.AdviceFertiBalancePk, false, true)
    }

     /**
    * Format en Pdf type conseil N reglementaire pilot SP
    * Dossier Réglementaire Pilotage Azote SP  propre au module conseil LAI
    * @returns PrintPdfExtraModel
    */
    public static FormatPdfTypePilotSpAdviceNReg(): PrintPdfExtraModel {
        return new PrintPdfExtraModel(PrintManager.code_print_regulatory_pilot_lai, "Dossier Réglementaire Pilotage Azote SP", eDownloadPdfs.RegulatoryAdviceSp)
    }
}

/**
 * Enumeration des pdf exportables
 *  print.op
 */
export enum eDownloadPdfs {
    /** Diagnostic Fetilité*/
    DiagnosticFertilité = 1,
    /**Diagnostic Potentiel */
    DiagnocticPotentiel = 2,
    /**Conseil Fumure epicles | GRCETA (depuis RESTITUTION) */
    ConseilFumure = 3,
    /**Conseil Azote (epicles) */
    ConseilAzote = 4,
    /**Preconisation conseil BEAPI | GRCETA (depuis RESTITUTION)*/
    Préconisations = 5,
    /**Modulation */
    Modulations = 6,
    /**Données annuels */
    Annuals = 7,
    /**Interventions Mode préco */
    ModePreco = 8,
    /**(diagnostic Step8) Pilot N SP LAI */
    DiagSpLai = 9,
    /**Impression preconisation LAI */
    PrecoPilotNSpLai = 10,
    /**Conseil Ns Pilot SP */
    AdvicePilotNSpLai = 11,
    /**Synthèse des besoins en engrais(GRID Preco fumure+ Pilotage AzoteSP) */
    SynthFertilizerNeeds = 12,
    /**Synthèse des besoins en autres intrant(GRID Modulation) */
    SynthOtherInputNeeds = 13,
    /**Impression Solde conseil Pk Initial EPICLES*/
    AdviceInitialBalancePk = 14,
    /**Impression Solde conseil Pk Initial Epicles */
    AdviceFertiBalancePk = 15,
    /**Synthèse des besoins en engrais GRCETA propre au module conseil GRCETA (non restitution) */
    SynthGRCETAFertiNeeds = 16,
    /**Preconisation GRCETA propre au module conseil GRCETA (non restitution) */
    PrecosGrCeta = 17,
    /**Conseil calculé GRCETA propre au module conseil GRCETA (non restitution) */
    AdviceGrCeta = 18,
    /**Dossier Réglementaire Pilotage Azote SP  propre au module conseil LAI */
    RegulatoryAdviceSp = 19
}

/**Model Impression PDF */

export class PrintPdfExtraModel {
    /**Code unique identifiant le type d'impression */
    public code: string
    /**Titre affiché au client dans la liste d'impression*/
    public title: string
    /**type enum lié à l'impression */
    public type: eDownloadPdfs

    /**si on ajout un saut de ligne avant celui-ci */
    public lineBreakBefore: boolean = false;
    /**Si on ajout un saut d ligne après celui ci */
    public lineBreakAfter: boolean = false;


    /**titre à afficher */
    public get value() {
        return this.title;
    }
    /**
     * Initialisation
     * @param _iCode Code unique identifiant le type d'impression
     * @param _iUserText Titre affiché au client dans la liste d'impression
     * @param _iPdfType type enum lié à l'impression
     * @param _iSetLineBreakerBefore true on met un saut de ligne avant celui ci
     * @param _iSetLineBreakerAfter true on met un saut de ligne après celui ci
     */
    public constructor(_iCode: string, _iUserText: string, _iPdfType: eDownloadPdfs, _iSetLineBreakerBefore: boolean = false, _iSetLineBreakerAfter: boolean = false) {
        this.code = _iCode;
        this.title = _iUserText;
        this.type = _iPdfType;
        this.lineBreakBefore = _iSetLineBreakerBefore;
        this.lineBreakAfter = _iSetLineBreakerAfter;
    }

}